/* Blog v3 (docs/build/blog-v3/README.md).
   1. The listing's Topics menu (sections/xp-blog.liquid): a <details> disclosure that already works without this
      script; here it also closes on Esc (focus back on its button) and on a click outside it. */
(() => {
  'use strict';
  const menu = document.querySelector('[data-xp-blog-topics]');
  if (!menu) return;
  document.addEventListener('click', (e) => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
  menu.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !menu.open) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
})();

/* 2. Article contents (sections/xp-article.liquid).
   Builds "On this page" from the body's h2 and h3 into both lists (the sticky side list from 1051 px, the closed
   accordion below that), marks the section being read, and keeps heading links working:
   - headings keep the ids they were written with (the kit posts link to #print-shop, #returns and others); a
     heading without one gets an id from its text, unique on the page;
   - #heading-N, the ids the old theme's script gave (every h2 and h3 in the body, counted from 0), still lands on
     the same heading.
   Skipped: headings inside kit pick cards, the FAQ, figures, tables, details and quotes. Fewer than two headings: no
   list. Without JavaScript nothing shows and the body reads the same. */
(() => {
  'use strict';
  const body = document.querySelector('[data-xp-art-body]');
  if (!body) return;

  // Plain tables (posts without the blog kit; the section wraps them in .xp-art__table): label every cell with its
  // column heading so phones can show each row as a small card (xp-blog.css, max-width 640 px). A table without a
  // heading row keeps the sideways scroll.
  body.querySelectorAll('.xp-art__table').forEach((wrap) => {
    const table = wrap.querySelector('table');
    if (!table || !table.rows.length) return;
    let head = table.tHead && table.tHead.rows[0];
    if (!head && Array.from(table.rows[0].cells).every((c) => c.tagName === 'TH')) head = table.rows[0];
    if (!head) return;
    const labels = Array.from(head.cells, (c) => c.textContent.replace(/\s+/g, ' ').trim());
    Array.from(table.rows).forEach((row) => {
      if (row === head || row.parentElement === table.tHead) return;
      Array.from(row.cells).forEach((cell, i) => { if (labels[i]) cell.setAttribute('data-label', labels[i]); });
    });
    if (!table.tHead) head.classList.add('xp-art__headrow');
    wrap.classList.add('xp-art__table--stack');
  });

  const all = Array.from(body.querySelectorAll('h2, h3'));
  const heads = all.filter((h) => !h.closest('.xn-pick, .xn-faq, figure, table, details, blockquote, [hidden], [aria-hidden="true"]') && h.textContent.trim());

  const taken = new Set(Array.from(document.querySelectorAll('[id]'), (el) => el.id));
  const made = new Set();
  const slug = (t) => t.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/['\u2019]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64).replace(/-+$/, '') || 'section';
  heads.forEach((h) => {
    if (h.id) return;
    const base = slug(h.textContent);
    let id = base;
    for (let n = 2; taken.has(id); n++) id = `${base}-${n}`;
    h.id = id;
    taken.add(id);
    made.add(id);
  });

  // A fragment the browser couldn't resolve on load: an id made just now, or an old #heading-N.
  const jump = (el) => { if (el) requestAnimationFrame(() => el.scrollIntoView({ block: 'start' })); };
  let hash = '';
  try { hash = decodeURIComponent(location.hash.slice(1)); } catch (e) { hash = ''; }
  const legacy = /^heading-(\d+)$/.exec(hash);
  if (made.has(hash)) jump(document.getElementById(hash));
  else if (legacy && !document.getElementById(hash)) jump(all[Number(legacy[1])]);

  if (heads.length < 2) return;
  const links = heads.map(() => []);
  document.querySelectorAll('[data-xp-art-toc]').forEach((list) => {
    const frag = document.createDocumentFragment();
    heads.forEach((h, i) => {
      const li = document.createElement('li');
      li.className = h.tagName === 'H3' ? 'xp-art-toc__item xp-art-toc__item--sub' : 'xp-art-toc__item';
      const a = document.createElement('a');
      a.className = 'xp-art-toc__link';
      a.href = '#' + encodeURIComponent(h.id);
      a.textContent = h.textContent.replace(/\s+/g, ' ').trim();
      li.appendChild(a);
      frag.appendChild(li);
      links[i].push(a);
    });
    list.appendChild(frag);
  });
  const side = document.querySelector('[data-xp-art-side]');
  const tocm = document.querySelector('[data-xp-art-tocm]');
  if (side) side.hidden = false;
  if (tocm) {
    tocm.hidden = false;
    // Close the accordion once a section is picked, so the reader lands on the section, not on an open list.
    tocm.addEventListener('click', (e) => { if (e.target.closest('a')) tocm.open = false; });
  }

  // The section being read: the last heading above the header line.
  let current = -1;
  let queued = false;
  const update = () => {
    queued = false;
    const line = (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 88) + 8;
    let i = -1;
    for (let k = 0; k < heads.length; k++) {
      if (heads[k].getBoundingClientRect().top <= line) i = k;
      else break;
    }
    if (i === current) return;
    if (current > -1) links[current].forEach((a) => a.removeAttribute('aria-current'));
    current = i;
    if (i < 0) return;
    links[i].forEach((a) => a.setAttribute('aria-current', 'true'));
    // A long list scrolls inside the sticky column: keep the current row in its upper third.
    if (side && side.scrollHeight > side.clientHeight + 1) {
      const a = links[i].find((l) => side.contains(l));
      if (a) {
        const top = a.offsetTop - side.scrollTop;
        if (top < 24 || top > side.clientHeight - 48) side.scrollTop = Math.max(0, a.offsetTop - side.clientHeight / 3);
      }
    }
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue, { passive: true });
  update();
})();
